module.exports = __webpack_public_path__ + "img/DE00660.35640b7c.png";